'use client';

import { datadogRum, RumEvent } from '@datadog/browser-rum';
import { useEffect } from 'react';
import { datadogLogs } from '@datadog/browser-logs';

const InitDataDog = ({
  service,
  version,
}: {
  service: string;
  version: string;
}) => {
  useEffect(() => {
    datadogRum.init({
      applicationId: process.env.NEXT_PUBLIC_SECRET_DATADOG_APP_ID as string,
      clientToken: process.env
        .NEXT_PUBLIC_SECRET_DATADOG_CLIENT_TOKEN as string,
      site: 'datadoghq.eu',
      service,
      env: process.env.NEXT_PUBLIC_SECRET_DATADOG_ENV as string,
      version,
      sessionSampleRate: 100,
      sessionReplaySampleRate: 100,
      trackUserInteractions: true,
      trackResources: true,
      trackLongTasks: true,
      defaultPrivacyLevel: 'mask-user-input',
      beforeSend: (event: RumEvent) => {
        if (event.view.url?.includes('/country/')) {
          event.context = {
            ...(event.context || {}),
            country: event.view.url.split('/country/')[1].substring(0, 2),
          };
          event.view.url = event.view.url.replace(
            /country\/[a-zA-Z]{2}/,
            'country',
          );
        }
        return true;
      },
    });
    datadogRum.setGlobalContextProperty('business_unit', 'bcp');
    datadogRum.setGlobalContextProperty('invoiced_team', 'ce-onebooking-front');

    datadogRum.startSessionReplayRecording();

    datadogLogs.init({
      clientToken: process.env
        .NEXT_PUBLIC_SECRET_DATADOG_CLIENT_TOKEN as string,
      site: 'datadoghq.eu',
      service,
      forwardErrorsToLogs: true,
      sessionSampleRate: 100,
      env: process.env.NEXT_PUBLIC_SECRET_DATADOG_ENV as string,
      version,
      forwardConsoleLogs: 'all',
    });
  }, []);

  return null;
};

export default InitDataDog;
